import React from 'react';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#FBFBF9',
                    fontFamily: 'Outfit, sans-serif',
                    padding: '2rem'
                }}>
                    <div style={{ textAlign: 'center', maxWidth: '400px' }}>
                        <div style={{
                            width: '64px', height: '64px',
                            background: '#425A65', borderRadius: '16px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 1.5rem'
                        }}>
                            <span style={{ color: 'white', fontSize: '28px', fontWeight: 'bold' }}>S</span>
                        </div>
                        <h2 style={{ color: '#1F2A30', fontSize: '1.25rem', marginBottom: '0.75rem' }}>
                            Algo salió mal
                        </h2>
                        <p style={{ color: '#616E7C', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
                            Ha ocurrido un error inesperado. Por favor, recarga la página para continuar.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                background: '#3E5F6E', color: 'white',
                                border: 'none', borderRadius: '12px',
                                padding: '0.75rem 2rem', fontSize: '0.875rem',
                                fontWeight: '500', cursor: 'pointer'
                            }}
                        >
                            Recargar página
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
